// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__6o4Rx","rootSuccess":"CompleteLink_rootSuccess__1pbK1","rootFailure":"CompleteLink_rootFailure__37itp","isDisabled":"CompleteLink_isDisabled__38sNm"};